import { render } from "./password_reset_complete.html?vue&type=template&id=162ddb8b&external"
import script from "./password_reset_complete.js?vue&type=script&lang=js&external"
export * from "./password_reset_complete.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__